import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomMonthAndYearDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }

  override getMonthNames(): string[] {
    return ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
      'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
  }

  override format(date: Date): string {
    const month = this.convertToTwoSymbols(date.getMonth() + 1);

    return `${month}.${date.getFullYear()}`;
  }

  private convertToTwoSymbols(value: number): string {
    const stringValue = String(value);
    const valueLength = stringValue.length;

    return valueLength > 1 ? stringValue : `0${stringValue}`;
  }
}
